import sliceCreator from '../../index.jsx';
import { CREATE_FARMER_COMMITMENT} from '../../../constants/index.jsx';
const _createFarmerCommitmentAction = sliceCreator('CREATE_FARMER_COMMITMENT', CREATE_FARMER_COMMITMENT, 'post');

const { asyncAction: createFarmerCommitmentAction, reducer, clearData: clearCreateFarmerCommitmentAction } = _createFarmerCommitmentAction;

export default reducer;

export {
    createFarmerCommitmentAction,
    clearCreateFarmerCommitmentAction
}